import React from 'react'
import { Bars } from 'react-loader-spinner'

const ButtonLoader = () => {
    return (
        <div className='w-100 d-flex align-items-center justify-content-center'>
            <Bars
                height="20"
                width="20"
                color="#fff"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            />
        </div>
    )
}

export default ButtonLoader